import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';
import { textCardsData } from 'constants/requirements';

export const requirementsAnimation = () => {
  const mm = gsap.matchMedia();

  const gsapInit = context => {
    const { isMobile } = context.conditions;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#${SECTIONS_IDS.requirements}`,
        end: '+=3000',
        scrub: true,
        pin: true,
        pinSpacing: 'padding',
        invalidateOnRefresh: true,
      },
    });

    // Появление title
    tl.to(`#${SECTIONS_IDS.requirements}-title`, { opacity: 1, pointerEvents: 'all' });

    // Появление слайдера или карточек по одной
    if (isMobile) {
      tl.to(`#${SECTIONS_IDS.requirements}-cards-slider`, { opacity: 1, pointerEvents: 'all' });
    } else {
      textCardsData.forEach((_, i) =>
        tl.to(`#${SECTIONS_IDS.requirements}-text-card-${i}`, { opacity: 1, pointerEvents: 'all' }),
      );
    }

    // Исчезновение title вместе со слайдером или всеми карточками
    tl.fromTo(
      `#${SECTIONS_IDS.requirements}-first-container`,
      { opacity: 1, pointerEvents: 'all' },
      { opacity: 0, pointerEvents: 'none' },
    );
    tl.to(`#${SECTIONS_IDS.requirements}-cup`, { opacity: 1, pointerEvents: 'all' });
    tl.to(`#${SECTIONS_IDS.requirements}-second-container`, { opacity: 1, pointerEvents: 'all' });
  };

  mm.add(
    {
      isLaptop: '(min-width: 992px)',
      isTablet: '(min-width: 656px) and (max-width:991px)',
      isMobile: '(max-width: 655px)',
    },
    context => gsapInit(context),
  );
};
